import { FC } from 'react'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { Link } from '@dtx-company/design-system/src'

export interface SubHeadingLinkProps {
  selectedPlan: Plan | undefined
}

export const SubHeadingLink: FC<SubHeadingLinkProps> = _ => {
  return (
    <Link
      variant="bodySmall"
      href={Routes.SELECT_PLAN}
      target="_blank"
      rel="noreferrer"
      onClick={() => {
        fireAnalyticsEvent('Revenue_Upgrade_Clicked_LearnMoreLink')
      }}
    >
      {'Learn more about this plan ->'}
    </Link>
  )
}
